<template>
    <v-card>
        <v-card-title>Issue Templates</v-card-title>

        <v-divider />

        <v-card-text class="mt-4">

            <v-data-table :headers="headers" :items="templatesList" :items-per-page="-1" hide-default-footer>
                <template v-slot:item.issue.issue_open_time="{ item }">
                    {{item.issue.issue_open_time}}
                </template>
                <template v-slot:item.issue.issue_revised_time="{ item }">
                    {{item.issue.issue_revised_time}}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn icon @click="editTemplate(item)" :disabled="lockSave"><v-icon>mdi-pencil</v-icon></v-btn>
                    <v-btn icon @click="deleteTemplateClick(item)" :disabled="lockSave"><v-icon>mdi-delete</v-icon></v-btn>
                </template>
                <template v-slot:item.create="{ item }">
                    <v-btn icon @click="createIssueFromTemplate(item)"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
                </template>
            </v-data-table>

            <v-btn class="mt-5" text @click="addNewTemplate" :disabled="lockSave"><v-icon small class="mr-1">mdi-plus-circle-outline</v-icon> Create New Template</v-btn>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="closeClick">Close</v-btn>
        </v-card-actions>


        <v-dialog v-model="showIssueDetails" max-width="80%" width="1600px" persistent>
            <issue-details v-if="showIssueDetails" @close="closeTemplateDetails" @saved="wasSaved" :issue="selectedTemplate" :type="selectedTemplateType" :resources="$props.resources" :templateName="templateName" :templatesNamesList="templatesNamesList"></issue-details>
        </v-dialog>

    </v-card>
</template>

<script>
import IssueDetails from "@/components/Issues/IssueDetails";
export default {
    name: 'IssueTemplates',
    props: ['resources'],
    components: {
        IssueDetails
    },
    data: () => ({
        templatesList: [],
        lockSave: false,
        showIssueDetails: false,
        selectedTemplateObj: null,
        selectedTemplate: null,
        selectedTemplateType: null,
        templateName: null,

        headers: [
            {text: 'Template Name', align: 'start', sortable: true, value: 'name'},
            {text: 'Created Time', align: 'start', sortable: true, value: 'issue.issue_open_time', sort: (a,b) => {return TELSA.moment(a) - TELSA.moment(b);}},
            {text: 'Revised Time', align: 'start', sortable: true, value: 'issue.issue_revised_time', sort: (a,b) => {return TELSA.moment(a) - TELSA.moment(b);}},
            {text: 'Edit/Delete', align: 'end', sortable: false, value: 'actions'},
            {text: 'Create Issue', align: 'center', sortable: false, value: 'create'},
        ]
    }),

    computed: {
        templatesNamesList() {
            return this.templatesList.map(x => x.name);
        }
    },

    methods: {
        getIssueTemplates: function() {
            let route = `${TELSA.apiHost}issues/templates/list`;
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log('templatesList', result);
                this.templatesList = result;
                TELSA.loading(false);
            });
        },

        createIssueFromTemplate: function(template) {
            this.$emit('createIssue', template.name);
        },

        editTemplate: function(template) {
            this.selectedTemplateObj = template;
            this.selectedTemplate = template.issue;
            this.templateName = template.name;
            this.selectedTemplateType = 'edit_template'
            this.showIssueDetails = true;
        },

        deleteTemplateClick: function(template) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Issue Template',
                message: `This operation will permanently delete issue template <b>${template.name}</b>. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteTemplate(template)
            });
        },
        deleteTemplate: function(template) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}issues/templates/delete`;
            this.$http.post(route, {args: {lock: (this.$store.state.lock ? this.$store.state.lock: {}), template_issue_id: template.issue.issue_id, template_name: template.name}}).then(response => {
                let result = response.body;
                this.getIssueTemplates();
            });
        },

        addNewTemplate: function() {
            let route = `${TELSA.apiHost}issues/new`;
            this.$http.get(route).then(response => {
                let newIssueId = response.body;
                this.templateName = '';
                this.selectedTemplate = {
                    alarm_full_text: "",
                    alarm_id: 0,
                    issue_affected: 0,
                    issue_affected_type: "Users",
                    issue_autoclose_time: "",
                    issue_category: "[Unassigned]",
                    issue_cause: "[Unassigned]",
                    issue_close_time: null,
                    issue_close_user: null,
                    issue_description: "",
                    issue_due_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).add(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    issue_duplicate_id: 0,
                    issue_fcc_status:"[not reportable]",
                    issue_history: [],
                    issue_id: newIssueId,
                    issue_ip_members: "",
                    issue_ip_options: "0;0",
                    issue_open_time: null, // This will be set to now() upon save
                    issue_open_user: this.$store.state.user.user_username,
                    issue_options: "0;0",
                    issue_owner: this.$store.state.user.user_username,
                    issue_priority: "Normal",
                    issue_remarks: [],
                    issue_revised_time: null, // This will be set to now() upon save
                    issue_services: "",
                    issue_severity: "OBSERVATIONAL",
                    issue_solution: "",
                    issue_solve_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss'), // This will be nulled out if disabled upon save
                    issue_start_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss'),
                    issue_status: "Open",
                    issue_title: "",
                    issue_update_due: 0,
                    site_id: [],
                    site_locale: [],
                    site_location: [],
                    site_name: [],
                    site_office: [],
                    user_username: [],
                };
                //this.selectedTemplateObj = template;
                this.selectedTemplateType = 'new_template'
                this.showIssueDetails = true;
            });
        },

        wasSaved: function(template) {
            if(this.selectedTemplateType == 'edit_template') {
                this.selectedTemplateObj.name = template.issue_template_name;
            }
            this.getIssueTemplates();
            this.closeTemplateDetails();
        },

        closeTemplateDetails: function() {
            this.showIssueDetails = false;
            this.selectedTemplateObj = null;
            this.selectedTemplate = null;
            this.selectedTemplateType = null;
            this.templateName = null;
        },

        closeClick: function() {
            // if(this.$store.state.isDirty) {
            //     this.$store.commit('showConfirmModal', {
            //         title: 'Are you sure?',
            //         message: `Are you sure you want to discard changes to Issue templates?`,
            //         type: 'warning',
            //         hideCancel: false,
            //         confirmAction: () => {this.$store.commit('setIsDirty', true); this.$emit('close')}
            //     });
            // }
            // else {
            //     this.$store.dispatch('handleRemoveLocks');
            //     this.$emit('close');
            // }

            this.$store.dispatch('handleRemoveLocks');
            this.$emit('close');
        },
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/issue/edit-templates');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getIssueTemplates()}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_issue_templates`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getIssueTemplates().then(v => {
                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The Issue templates are already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot edit them at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
                TELSA.loading(false);
            });
        });
    }


};
</script>

<style scoped>

</style>
